import { Button, Form, Input, InputNumber, message, Row, Space, Spin, Typography } from 'antd';
import React from 'react';
import axios from '../../request/axios';

const {Text} = Typography;

class TaobaoShopSettings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      form_loading: false,
      form_submitting: false,
      taobao_buyer_purchase_frequency_minutes: null,
      taobao_buyer_purchase_frequency_times: null
    };
  }

  componentDidMount() {
    this.setState({form_loading: true});
    axios.get('customer-shop-settings').then(res => {
      const {data} = res.data;
      this.setState({
        taobao_buyer_purchase_frequency_minutes: data.taobao_buyer_purchase_frequency_minutes,
        taobao_buyer_purchase_frequency_times: data.taobao_buyer_purchase_frequency_times
      });

      data.taobao_buyer_nick_white_list = data.taobao_buyer_nick_white_list?.join('\n');
      data.taobao_buyer_nick_black_list = data.taobao_buyer_nick_black_list?.join('\n');
      data.taobao_charge_account_black_list = data.taobao_charge_account_black_list?.join('\n');

      this.formRef && this.formRef.setFieldsValue(data);
    }).finally(() => {
      this.setState({form_loading: false});
    });
  }

  onFinish = (values) => {
    this.setState({form_submitting: true});

    values.taobao_buyer_purchase_frequency_minutes = this.state.taobao_buyer_purchase_frequency_minutes;
    values.taobao_buyer_purchase_frequency_times = this.state.taobao_buyer_purchase_frequency_times;

    axios.post('customer-shop-settings/taobao', values).then(() => {
      message.success('保存成功');
    }).finally(() => {
      this.setState({form_submitting: false});
    });
  };

  render() {
    return (
      <Spin spinning={this.state.form_loading}>
        <Form ref={ref => this.formRef = ref} onFinish={this.onFinish} labelCol={{span: 4}} wrapperCol={{span: 20}}>

          <Form.Item
            label='交易频率'
            extra='对同一买家的购买频率限制，如不需要可不填'
          >
            <Input.Group>
              <Row gutter={8} align='middle'>
                <Text>同一买家每</Text> &nbsp;&nbsp;
                <InputNumber min={1} style={{width: 70}} value={this.state.taobao_buyer_purchase_frequency_minutes}
                             onChange={value => this.setState({taobao_buyer_purchase_frequency_minutes: value})}/>&nbsp;&nbsp;
                <Text>分钟内，最多购买</Text>&nbsp;&nbsp;
                <InputNumber min={1} style={{width: 70}} value={this.state.taobao_buyer_purchase_frequency_times}
                             onChange={value => this.setState({taobao_buyer_purchase_frequency_times: value})}/>&nbsp;&nbsp;
                <Text>笔订单</Text>
              </Row>
            </Input.Group>
          </Form.Item>

          <Form.Item
            name='taobao_maximum_amount_per_order'
            label='订单最大交易金额'
            extra='单笔订单的最大交易金额，当大于所设置金额时，该笔订单将被忽略不予处理'
            rules={[
              ({getFieldValue}) => ({
                validator(_, value) {
                  if (!value || (!isNaN(value) && parseFloat(value) >= 0.0001 && parseFloat(value) < 90000000)) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('请输入正确的金额'));
                }
              })
            ]}
          >
            <Input style={{width: 130, textAlign: 'right'}} addonBefore='￥' suffix='元'/>
          </Form.Item>

          <Form.Item
            name='taobao_buyer_nick_white_list'
            label='买家昵称白名单'
            extra='一行一个买家昵称，处于白名单的买家，不受单笔订单最大交易金额和购买频率限制'
          >
            <Input.TextArea style={{width: 450}} autoSize={{minRows: 3, maxRows: 10}}/>
          </Form.Item>

          <Form.Item
            name='taobao_buyer_nick_black_list'
            label='买家昵称黑名单'
            extra='一行一个买家昵称，处于黑名单的买家，忽略订单不予处理'
          >
            <Input.TextArea style={{width: 450}} autoSize={{minRows: 3, maxRows: 10}}/>
          </Form.Item>

          <Form.Item
            name='taobao_charge_account_black_list'
            label='充值账号黑名单'
            extra='一行一个充值账号，处于黑名单的充值账号，忽略订单不予处理'
          >
            <Input.TextArea style={{width: 450}} autoSize={{minRows: 3, maxRows: 10}}/>
          </Form.Item>

          <Form.Item
            wrapperCol={{
              offset: 4,
              span: 10
            }}
          >
            <Space>
              <Button type='primary' htmlType='submit' loading={this.state.form_submitting}>
                保存
              </Button>
              <Button onClick={this.handleReturn}>
                返回
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Spin>
    );
  }
}

export default TaobaoShopSettings;